import RequestActionHelper from '@kakadu-dev/base-frontend-helpers/helpers/Redux/RequestActionHelper'
import { STATIC_PAGES_ACTION } from './actionTypes'

export const StaticPagesActions = {
	pages: RequestActionHelper.getActionCreatorFetch(STATIC_PAGES_ACTION.PAGES_LIST),
	getArticles: RequestActionHelper.getActionCreatorFetch(STATIC_PAGES_ACTION.ARTICLES),
	setArticles: RequestActionHelper.getActionCreatorSuccess(STATIC_PAGES_ACTION.ARTICLES),
	banners: RequestActionHelper.getActionCreatorFetch(STATIC_PAGES_ACTION.BANNERS),
}
